import { dataLayerPush } from './dataLayerPush';

export const filterEvents = {
  applyFilter: (screenName, appliedFilterNames) => dataLayerPush({ event: 'filter_add', screen_name: screenName, filters: appliedFilterNames }),
  sortStart: (screenName) => dataLayerPush({ event: 'sort_start', screen_name: screenName }),
  sortSuccessful: (screenName) => dataLayerPush({ event: 'sort_successful', screen_name: screenName }),
};
